import React from 'react';
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './Step1Company.module.css';

const COUNTRIES = [
  'China', 'United States', 'United Kingdom', 'Germany', 'France',
  'India', 'Japan', 'South Korea', 'Australia', 'Canada',
  'Singapore', 'United Arab Emirates', 'Saudi Arabia', 'Brazil', 'Mexico',
  'Netherlands', 'Italy', 'Spain', 'Turkey', 'Indonesia',
];

const AgentStep1Info = ({ nextStep, initialValues }) => {
  const validate = values => {
    const errors = {};
    if (!values.companyName?.trim()) errors.companyName = 'Company / individual name is required';
    if (!values.registrationNumber?.trim()) errors.registrationNumber = 'Business registration number is required';
    if (!values.country) errors.country = 'Please select a country';
    if (!values.city?.trim()) errors.city = 'City is required';
    return errors;
  };

  return (
    <Form
      onSubmit={nextStep}
      validate={validate}
      initialValues={initialValues}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={css.form}>

          <div className={css.header}>
            <span className={css.step}>Step 1 of 5</span>
            <h2 className={css.title}>Agent / Company Information</h2>
            <p className={css.description}>
              Tell us about your company or yourself as a sourcing agent.
            </p>
          </div>

          <hr className={css.divider} />

          {/* ── Identity ── */}
          <section className={css.section}>
            <h3 className={css.sectionTitle}>Identity Details</h3>

            <div className={css.fieldFull} style={{ marginBottom: 18 }}>
              <label className={css.label}>
                Company / Individual Name <span className={css.required}>*</span>
              </label>
              <Field name="companyName">
                {({ input, meta }) => (
                  <>
                    <input
                      {...input}
                      type="text"
                      className={classNames(css.input, { [css.inputError]: meta.touched && meta.error })}
                      placeholder="e.g. GlobalLink Sourcing Co. or John Smith"
                    />
                    {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
                  </>
                )}
              </Field>
            </div>

            <div className={css.fieldFull} style={{ marginBottom: 18 }}>
              <label className={css.label}>
                Business Registration Number <span className={css.required}>*</span>
              </label>
              <Field name="registrationNumber">
                {({ input, meta }) => (
                  <>
                    <input
                      {...input}
                      type="text"
                      className={classNames(css.input, { [css.inputError]: meta.touched && meta.error })}
                      placeholder="Enter registration number"
                    />
                    {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
                  </>
                )}
              </Field>
            </div>

            <div className={css.flex}>
              <div className={css.field}>
                <label className={css.label}>
                  Country <span className={css.required}>*</span>
                </label>
                <Field name="country">
                  {({ input, meta }) => (
                    <>
                      <select
                        {...input}
                        className={classNames(css.select, { [css.inputError]: meta.touched && meta.error })}
                      >
                        <option value="">Select Country</option>
                        {COUNTRIES.map(c => (
                          <option key={c} value={c}>{c}</option>
                        ))}
                      </select>
                      {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
                    </>
                  )}
                </Field>
              </div>

              <div className={css.field}>
                <label className={css.label}>
                  City <span className={css.required}>*</span>
                </label>
                <Field name="city">
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="text"
                        className={classNames(css.input, { [css.inputError]: meta.touched && meta.error })}
                        placeholder="Enter city"
                      />
                      {meta.touched && meta.error && <span className={css.error}>{meta.error}</span>}
                    </>
                  )}
                </Field>
              </div>
            </div>
          </section>

          {/* ── Company Description ── */}
          <section className={css.section}>
            <h3 className={css.sectionTitle}>Company Description</h3>
            <div className={css.fieldFull}>
              <label className={css.label}>About Your Business <span style={{ color: '#94a3b8', fontWeight: 400 }}>(Optional)</span></label>
              <Field name="companyDescription">
                {({ input }) => (
                  <textarea
                    {...input}
                    rows={4}
                    className={css.textarea}
                    placeholder="Briefly describe your sourcing experience, specialization, and what makes you a trusted agent…"
                  />
                )}
              </Field>
            </div>
          </section>

          <div className={css.infoBox}>
            <h4>Next Step:</h4>
            <p>Add your contact person details and set up your account credentials.</p>
          </div>

          <div className={css.buttonContainer}>
            <button type="submit" className={css.button}>
              Next : Contact Details →
            </button>
          </div>

        </form>
      )}
    />
  );
};

AgentStep1Info.defaultProps = { initialValues: {} };
AgentStep1Info.propTypes = {
  nextStep: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default AgentStep1Info;
